export default __webpack_public_path__ + "static/media/Tunic of the Spheres.29534ff4.jpg";